// extracted by mini-css-extract-plugin
export default {"text":"ytQmhvA5sBxZ9Y0MUxtL","name":"MC5xBUuu3XsYAxB5nxT9","time":"ONL7Ai2dGNHx_PkZM7AF","project-actions":"ddAoXgyUY6camVfvc6SA","card":"F134X0h3K09ykc6xvTXE"};